<div class="flex h-full w-full items-center justify-center">
  <iframe
    #iframe
    *ngIf="navigationEnd()"
    [src]="iframeUrl | safe: 'resourceUrl'"
    (load)="isLoading.set(false)"
    [ngClass]="{
      'hidden!': isLoading() || !navigationEnd()
    }"
    width="100%"
    height="auto"
    [scrolling]="'auto'"
    style="border: none"></iframe>
  <p-progress-spinner *ngIf="isLoading()" aria-label="Loading"></p-progress-spinner>
</div>
